<template>
  <div :class="heroSchema.mobileBgColor">
    <div class="hero-banner-carousel__container" :style="{ 'max-width': heroSchema.maxWidth }">
      <div class="hero-banner-carousel">
        <hero-banner-carousel-desktop class="hero_banner_desktop" v-if="$mq !== 'mobile'" :hero-schema="heroSchema" :heroArray="heroArray"></hero-banner-carousel-desktop>
        <hero-banner-carousel-mobile class="hero_banner_mobile" v-if="$mq === 'mobile'" :hero-schema="heroSchema" :heroArray="heroArray"></hero-banner-carousel-mobile>
      </div>
    </div>
  </div>
</template>

<script>
import HeroBannerCarouselDesktop from '@/scripts/components/sections/HeroBannerCarouselDesktop.vue'
import HeroBannerCarouselMobile from '@/scripts/components/sections/HeroBannerCarouselMobile.vue'

export default {
  name: 'HeroBannerCarousel',
  components: {
    HeroBannerCarouselDesktop,
    HeroBannerCarouselMobile
  },
  props: {
    heroSchema: {
      type: Object,
      default: () => ({
        layoutHorizontal: String,
        layoutVertical: String,
        mobileBgColor: String
      })
    },
    heroArray: {
      type: Array,
      default: () => [
        {
          image: String,
          imageMobile: String,
          imageMobileEnable: Boolean,
          overlayEnable: Boolean,
          overlayColor: String,
          overlayOpacity: Number,
          preHeading: String,
          preHeadingColor: String,
          heading: String,
          headingColor: String,
          subHeading: String,
          subHeadingColor: String,
          copy: String,
          copyColor: String,
          enableCta: Boolean,
          ctaLayout: String,
          ctaText: String,
          ctaUrl: String
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.hero-banner-carousel {
  &__container {
    margin: 0 auto;
  }
}
</style>
